import { flashBagSuccess } from '@tools/flashbag';
import translation from '@tools/translations/translations';

export default function () {
  const isOfferPage = document.querySelector('.offer-details');
  const isManageOffersPage = document.getElementById('offer-app');
  if (isOfferPage) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "offer" */ '@organisms/offer/main');

    if (document.getElementById('combinator-choose-app')) {
      import(/* webpackChunkName: "combinator-choose" */ '@organisms/offer/combinator-choose/main');
    }

    if (document.getElementById('combinator-other-offers-app')) {
      import(/* webpackChunkName: "combinator-other-offers" */ '@organisms/offer/other-offers/main');
    }

    if (document.getElementById('primary-contact-status-app')) {
      // eslint-disable-next-line no-unused-expressions
      import(
        /* webpackChunkName: "online-status-app" */ '@organisms/offer/online-status/main'
      );
    }
  }

  if (isManageOffersPage) {
    import(
      /* webpackChunkName: "offer-vue-app" */ '@organisms/offer/offer-vue'
    );
  }

  if (isOfferPage || isManageOffersPage) {
    import(
      /* webpackChunkName: "manage-offers-app" */ '@organisms/offer/offer-state-modals'
    );
  }

  function addCopyLinkEventListener(HTMLElement, parent) {
    HTMLElement?.addEventListener('click', () => {
      navigator.clipboard.writeText(HTMLElement.dataset.url).then(() => {
        flashBagSuccess(translation().messages['offer.link.copied']);
        parent.classList.remove('active');
      });
    });
  }

  function addShareEmailEventListener(HTMLElement, parent) {
    HTMLElement?.addEventListener('click', () => {
      const email = '';
      const subject = '';
      const body = HTMLElement.dataset.url;
      const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      parent.classList.remove('active');
      window.open(mailtoLink, '_blank');
    });
  }

  document.querySelectorAll('[data-share]').forEach((shareButton) => {
    shareButton.addEventListener('click', () => {
      if (window.BREAKPOINTS.isTabletLarge || window.BREAKPOINTS.isDesktop || !window.navigator.share) {
        const modalId = shareButton.dataset.modal;
        const shareModal = document.getElementById(modalId);
        addCopyLinkEventListener(document.getElementById(`${modalId}-copy-link-button`), shareModal);
        addShareEmailEventListener(document.getElementById(`${modalId}-share-email-button`), shareModal);
        shareModal.classList.toggle('active');
        return;
      }

      navigator.share({
        title: '',
        text: '',
        url: shareButton.dataset.url,
      })
        .then(() => {
          flashBagSuccess(translation().messages['offer.shared']);
        })
        .catch(() => {}); // Generate an error when we cancel share, we ignore it
    });
  });

  const navbar = document.getElementById('navbar-offer');
  if (navbar) {
    const breakValue = window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet ? 44 : 100;
    window.addEventListener('scroll', () => {
      if (window.scrollY > breakValue) {
        navbar.classList.add('active');
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('active');
        navbar.classList.remove('scrolled');
      }
    });
  }
}
